// Subset of ReportCommissionColumnName from ReportingService

export enum CommissionReportTableGroupingColumnId {
  SaleId = 'saleId',
  MarketplaceName = 'marketplaceName',
  MarketplaceSaleId = 'marketplaceSaleId',
  Commissioner = 'commissioner',
  EventName = 'eventName',
  EventDateLocal = 'eventDateLocal',
  VenueName = 'venueName',
  EventId = 'eventId',
  EventStateName = 'eventStateName',
  SaleStatusName = 'saleStatusName',
  Section = 'section',
  SeatingRow = 'seatingRow',
  SeatFrom = 'seatFrom',
  SeatTo = 'seatTo',
  FulfillmentDate = 'fulfillmentDate',
  LastPaymentDate = 'lastPaymentDate',
  NetCommissionRate = 'netCommissionRate',
  NetCommissionRateOverride = 'netCommissionRateOverride',
  SaleBasisShare = 'saleBasisShare',
  IsCommissionEligible = 'isCommissionEligible',
  CommissionEligibilityDate = 'commissionEligibilityDate',
}

export enum CommissionReportTableValueColumnId {
  TotalNetProceeds = 'totalNetProceeds',
  Credits = 'credits',
  TotalCost = 'totalCost',
  Charges = 'charges',
  CommissionerCostsAndCharges = 'commissionerCostsAndCharges',
  CommissionerProceedsAndCredits = 'commissionerProceedsAndCredits',
  CommissionerProfitAndLoss = 'commissionerProfitAndLoss',
  OriginalProceeds = 'originalProceeds',
}

export const COMMISSION_REPORT_TABLE_FORMULA_COLUMNS: CommissionReportTableValueColumnId[] =
  Object.values(CommissionReportTableValueColumnId);

export const COMMISSION_REPORT_SUMMARY_UNSUPPORTED_METRICS: string[] = [
  CommissionReportTableGroupingColumnId.NetCommissionRate,
  CommissionReportTableGroupingColumnId.NetCommissionRateOverride,
  CommissionReportTableGroupingColumnId.SaleBasisShare,
  CommissionReportTableValueColumnId.Credits,
  CommissionReportTableValueColumnId.Charges,
  CommissionReportTableValueColumnId.OriginalProceeds,
  CommissionReportTableValueColumnId.TotalNetProceeds,
  CommissionReportTableValueColumnId.TotalCost,
];
